import {
  contextValue,
  contextReadOnly,
  contextSupportGallery,
  contextSupportTasksBids,
  contextSupportAddTasksBids,
  contextSidePanelNotSupported,
  contextReturnAddedContextID,
  contextPostMessageBack,
  contextSidePanelOpenByDefault,
  contextTurnOffPrepopConfirmation,
} from '../constants';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, useAppSelector } from '../redux/Store';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router';

const useQueryObjects = () => {
  const { queryObj } = useSelector((state: RootState) => state.contextId);
  const location = useLocation();

  const cloneAllowed = useMemo(() => {
    return true; //queryObj?.context !== contextValue?.INSPI;
  }, []);
  const allowAddtionalImageLabels = useMemo(() => {
    return queryObj?.context === contextValue?.INSPI;
  }, [queryObj?.context]);
  const saveWorkInfoWithSubmit = useMemo(() => {
    return queryObj?.context === contextValue?.INSPI;
  }, [queryObj?.context]);

  const readOnlyAfterSubmit = useMemo(() => {
    return queryObj?.context === contextValue?.INSPI;
  }, [queryObj?.context]);

  const isAuditResultsBySubmissionId = useMemo(() => {
    return queryObj?.context === contextValue?.AuditResultsBySubmissionId;
  }, [queryObj?.context]);

  const isContextReadOnly = useMemo(() => {
    const value = contextReadOnly[queryObj?.context] ?? true;
    return value;
  }, [queryObj?.context]);

  const isContextSupportSidePanel = useMemo(() => {
    const value = contextSidePanelNotSupported[queryObj?.context] ?? true;
    return value;
  }, [queryObj?.context]);

  const turnOffPrepopConfirmation = useMemo(() => {
    const value = contextTurnOffPrepopConfirmation[queryObj?.context] ?? false;
    return value;
  }, [queryObj?.context]);

  const isContextSidePanelOpenByDefault = useMemo(() => {
    const value = contextSidePanelOpenByDefault[queryObj?.context] ?? false;
    return value;
  }, [queryObj?.context]);

  const isContextSupportGallery = useMemo(() => {
    const value = contextSupportGallery[queryObj?.context] ?? false;
    return value;
  }, [queryObj?.context]);
  const isContextSupportTasksBids = useMemo(() => {
    const value = contextSupportTasksBids[queryObj?.context] ?? false;
    return value;
  }, [queryObj?.context]);
  const isContextSupportAddTasksBids = useMemo(() => {
    const value = contextSupportAddTasksBids[queryObj?.context] ?? false;
    return value;
  }, [queryObj?.context]);
  const isContextAddedIdReturned = useMemo(() => {
    const value = contextReturnAddedContextID[queryObj?.context] ?? false;
    return value;
  }, [queryObj?.context]);

  const supportMessageBack = useMemo(() => {
    const value = contextPostMessageBack[queryObj?.context] ?? false;
    return value;
  }, [queryObj?.context]);

  const orderNumber = React.useMemo(() => {
    const orderNumber = queryObj?.id?.split('|')[0];
    if (queryObj?.key === 'WorkOrder.OrderNumber') {
      return orderNumber;
    }
    const queryParams = new URLSearchParams(location.search);
    return queryParams.get('orderNumber') || '';
  }, [queryObj?.id, queryObj?.key, location.search]);

  const propertyLoanId = React.useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    return queryParams.get('propertyLoanId') || '';
  }, [location.search]);

  const submissionId = React.useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    return queryParams.get('submissionId') || '';
  }, [location.search]);

  return {
    queryObj,
    cloneAllowed,
    allowAddtionalImageLabels,
    saveWorkInfoWithSubmit,
    readOnlyAfterSubmit,
    isAuditResultsBySubmissionId,
    orderNumber,
    propertyLoanId,
    submissionId,
    isContextReadOnly,
    isContextSupportGallery,
    isContextSupportSidePanel,
    isContextSidePanelOpenByDefault,
    isContextSupportTasksBids,
    isContextSupportAddTasksBids,
    isContextAddedIdReturned,
    supportMessageBack,
    turnOffPrepopConfirmation,
  };
};

export default useQueryObjects;
